import config from '@/api/config';
import { requestOptions, toJSON } from '@/api/checkout';
import fetch from 'isomorphic-fetch';

export function logIn(email, password) {
  const URL = `${config.authEndPoint}/auth/login`;
  const opt = {
    ...requestOptions('POST'),
    body: JSON.stringify({ email, password }),
  };

  return fetch(URL, opt).then(toJSON).then(payload => {
    if (payload.error) {
      return Promise.reject(payload);
    }

    collectGoogleAnalyticsClientId(payload);

    return Promise.resolve(payload);
  });
}

function collectGoogleAnalyticsClientId(payload, measurementId = 'G-XWRHEDR7RB') {
  if (!window.gtag) {
    return;
  }

  window.gtag('get', measurementId, 'client_id', clientId => {
    const URL = `${config.authEndPoint}/profile/collect`;

    const opt = {
      method: 'POST',
      headers: { ...config.headers, 'X-Auth-Token': payload.token },
      body: JSON.stringify({ client_id: clientId })
    };

    fetch(URL, opt);
  });
}
